import { SalesforceAccountConstant } from '../common/salesforceAccountConstants.js';
function handleErrors(response) {
    if (!response.ok || response.status !== 200) {
        throw Error(response.statusText);
    }
    return response;
}
async function checkHubEmailAccess(hubSlug) {
    const requestUrl = `${process.env.AIMEE_SERVICES_API_URL}/hub/${hubSlug}`;
    const headers = new Headers();
    headers.append('Accept', `application/json`);
    headers.append('Content-Type', `application/json`);
    const response = await fetch(new Request(requestUrl, {
        headers,
    }))
        .then(handleErrors)
        .then(async (results) => {
        var _a, _b, _c;
        const json = await results.json();
        return (_c = (_b = (_a = json === null || json === void 0 ? void 0 : json.authentication) === null || _a === void 0 ? void 0 : _a.emailLogin) === null || _b === void 0 ? void 0 : _b.isDisabled) !== null && _c !== void 0 ? _c : false;
    })
        .catch(error => {
        // eslint-disable-next-line no-console
        console.log(requestUrl, error);
        return true;
    });
    return response;
}
function emailSignature(name, email) {
    const signature = `<p style='margin:0'><b><span style='font-size:13.0pt;
    font-family:"Arial",sans-serif;color:#1384AF'>${name}</span></b></p>
  <p style='margin:2.0pt 0'><span style='font-size:11.0pt;font-family:"Arial",sans-serif;
    color:#404040'>CFP®&nbsp;|&nbsp;</span><span style='color:black'><a href="http://www.financialfinesse.com/"><u><span
                      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#404040'>Financial
                      Finesse</span></u></a></span>
  </p>
  <p style='margin:2.0pt 0'><b><span
              style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#404040'>e:&nbsp;</span></b><u><span
              style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#1384AF'><a href="mailto:${email}"><u><span
                          style='font-size:11.0pt;color:#1384AF'>${email}</span></u></a></span></u></p>
  <p style='margin:2.0pt 0'><b><span style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#404040'>Discover our
              book:&nbsp;</span></b><span style='font-size:11.0pt;color:black'><a
              href="https://www.amazon.com/Money-Strong-Guide-Financial-Worries-ebook/dp/B0BG99CBJD/"><u><span
                      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#1384AF'>Money Strong: Your Guide to a
                      Life Free of
                      Financial Worries</span></u></a></span></p>
  <p style='margin:2.0pt 0'><b><span style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#404040'>Follow
              us:&nbsp;</span></b>
      <span style='font-size:11.0pt;color:black'><a href="https://www.linkedin.com/company/financial-finesse/"><u><span
                      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#1384AF'>LinkedIn</span></u></a></span><span
          style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#666666;'>&nbsp;|&nbsp;</span><span
          style='font-size:11.0pt;color:black'><a href="https://twitter.com/Fin_Finesse"><u><span
                      style='font-size:11.0pt;font-family:"Arial",sans-serif; color:#1384AF'>Twitter</span></u></a></span><span
          style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#666666;'>&nbsp;|&nbsp;</span><span
          style='font-size:11.0pt;color:black'><a href="https://www.forbes.com/sites/financialfinesse/"><u><span
                      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#1384AF'>Forbes
                      Blog</span></u></a></span><span
          style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#666666;'>&nbsp;|&nbsp;</span><span
          style='font-size:11.0pt;color:black'><a href="https://www.buzzsprout.com/1997766"><u><span
                      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:#1384AF;'>Podcast</span></u></a></span>
  </p>
  <p style='margin:2.0pt 0'>
      <a href="https://www.financialfinesse.com">
          <img src="https://cms.ffhub.com/wp-content/uploads/2023/02/ff-logo-icon.png" alt="Financial Finesse Logo"
              width="40" height="40"></a>
  </p>`;
    return signature;
}
export async function initializeWcConfig(fulfillment) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    const emailBody = typeof ((_b = (_a = fulfillment.fulfillment) === null || _a === void 0 ? void 0 : _a.email[0]) === null || _b === void 0 ? void 0 : _b.body) !== 'undefined'
        ? (_c = fulfillment.fulfillment) === null || _c === void 0 ? void 0 : _c.email[0].body
        : '';
    const hours = SalesforceAccountConstant.META_ACCOUNT_ID.includes(((_e = (_d = fulfillment.fulfillment) === null || _d === void 0 ? void 0 : _d.salesforceCase) === null || _e === void 0 ? void 0 : _e.accountId) || '')
        ? `9 am and 9 pm`
        : `9 am and 8 pm`;
    const emailException = SalesforceAccountConstant.EMAIL_EXCEPTION.includes((_h = (_g = (_f = fulfillment.fulfillment) === null || _f === void 0 ? void 0 : _f.salesforceCase) === null || _g === void 0 ? void 0 : _g.accountId) !== null && _h !== void 0 ? _h : '');
    const ssoOrHubless = await checkHubEmailAccess((_k = (_j = fulfillment.fulfillment) === null || _j === void 0 ? void 0 : _j.hubSlug) !== null && _k !== void 0 ? _k : '');
    let newHubUserGeneratedLine = '';
    if (!ssoOrHubless && ((_l = fulfillment.fulfillment) === null || _l === void 0 ? void 0 : _l.newHubUserGenerated) && !emailException) {
        newHubUserGeneratedLine = `You may also receive a separate email from me with your Financial Finesse Hub login information.`;
    }
    const referralParagraph = !SalesforceAccountConstant.META_ACCOUNT_ID.includes(((_o = (_m = fulfillment.fulfillment) === null || _m === void 0 ? void 0 : _m.salesforceCase) === null || _o === void 0 ? void 0 : _o.accountId) || '') &&
        ((_p = fulfillment.fulfillment) === null || _p === void 0 ? void 0 : _p.hubSlug) &&
        ![
            'meta-canada',
            'meta',
            'ascensus',
            'ascensusplus',
            'vrpa',
            'vrpaplus',
            'jmpc',
            'ip',
            'capitalgroup',
            'americanfunds',
            'thetrust',
            'takeda',
            'verizon',
        ].includes((_q = fulfillment.fulfillment) === null || _q === void 0 ? void 0 : _q.hubSlug)
        ? `Also, if you know of any colleagues that may benefit from our service feel free to <a href="${process.env.HUB_DOMAIN}/${(_r = fulfillment.fulfillment) === null || _r === void 0 ? void 0 : _r.hubSlug}/home?refer=email" target="_blank">click this link</a> to refer them.`
        : ``;
    const coachingLineString = ((_s = fulfillment.fulfillment) === null || _s === void 0 ? void 0 : _s.hubCoachingLine)
        ? `If you have any additional questions, you may call us back at ${(_t = fulfillment.fulfillment) === null || _t === void 0 ? void 0 : _t.hubCoachingLine} between ${hours} ET Monday through Friday. ${newHubUserGeneratedLine} ${referralParagraph}`
        : `${newHubUserGeneratedLine}`;
    const signatureString = emailSignature(((_u = fulfillment.fulfillment) === null || _u === void 0 ? void 0 : _u.coachName) || '', ((_v = fulfillment.fulfillment) === null || _v === void 0 ? void 0 : _v.coachEmail) || '');
    const tinymceConfig = {
        height: 600,
        menubar: false,
        browser_spellcheck: true,
        forced_root_block: 'p',
        statusbar: false,
        introductions: [
            'Thanks for joining me recently for our financial coaching session.',
            'It was a pleasure speaking with you during our financial coaching session.',
            'It was a pleasure speaking with you.',
            'It was a real pleasure speaking with you about #topic#.',
            'It was great speaking with you.',
            'Thanks for calling the Financial Coaching Line.',
            'Thanks so much for taking time to walk me through your financial goals.',
            'It was a pleasure speaking with you.',
            'Thanks for calling in to the Financial Coaching Line.',
        ],
        outros: [
            `I hope you found our call, and this follow up, to be helpful.`,
            `I hope you found our conversation helpful and informative.`,
        ],
        body: emailBody,
        coachingLine: coachingLineString,
        slug: (_w = fulfillment.fulfillment) === null || _w === void 0 ? void 0 : _w.coachId,
        firstName: ((_y = (_x = fulfillment.fulfillment) === null || _x === void 0 ? void 0 : _x.salesforceContact) === null || _y === void 0 ? void 0 : _y.goes_By__c)
            ? (_0 = (_z = fulfillment.fulfillment) === null || _z === void 0 ? void 0 : _z.salesforceContact) === null || _0 === void 0 ? void 0 : _0.goes_By__c
            : (_2 = (_1 = fulfillment.fulfillment) === null || _1 === void 0 ? void 0 : _1.salesforceContact) === null || _2 === void 0 ? void 0 : _2.firstName,
        fullName: (_3 = fulfillment.fulfillment) === null || _3 === void 0 ? void 0 : _3.coachId,
        advisorName: (_4 = fulfillment.fulfillment) === null || _4 === void 0 ? void 0 : _4.coachName,
        fulfillmentId: (_5 = fulfillment.fulfillment) === null || _5 === void 0 ? void 0 : _5.id,
        topic: ((_6 = fulfillment.fulfillment) === null || _6 === void 0 ? void 0 : _6.salesforceCase.topics_1__c)
            ? (_7 = fulfillment.fulfillment) === null || _7 === void 0 ? void 0 : _7.salesforceCase.topics_1__c
            : '',
        signature: signatureString,
        hubDomain: process.env.HUB_DOMAIN,
        referralParagraph,
    };
    return tinymceConfig;
}
export async function initializeGlobalWcConfig(fulfillment) {
    var _a;
    const emailBody = typeof ((_a = fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.email[0]) === null || _a === void 0 ? void 0 : _a.body) !== 'undefined' ? fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.email[0].body : '';
    const signatureString = emailSignature((fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.coachName) || '', (fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.coachEmail) || '');
    const tinymceConfig = {
        height: 600,
        menubar: false,
        browser_spellcheck: true,
        forced_root_block: 'p',
        statusbar: false,
        introductions: [
            'It was a pleasure speaking with you during our financial coaching session.',
            'It was great speaking with you.',
        ],
        outros: [
            `I hope you found our call, and this follow up, to be helpful.`,
            `I hope you found our conversation helpful and informative.`,
        ],
        body: emailBody,
        slug: fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.coachId,
        firstName: fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.firstName,
        fullName: fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.coachId,
        advisorName: fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.coachName,
        fulfillmentId: fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.id,
        signature: signatureString,
        hubDomain: process.env.HUB_DOMAIN,
    };
    return tinymceConfig;
}
export function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window
        .atob(base64)
        .split('')
        .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''));
    return JSON.parse(jsonPayload);
}
export function setObjectProperty(obj, path, value) {
    let route = path;
    if (typeof route === 'string') {
        route = route.replace(/\[(\d+)\]/g, '.$1').split('.');
    }
    else if (!Array.isArray(route)) {
        throw new Error('route must be a string or an array');
    }
    let current = obj;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < route.length - 1; i++) {
        const key = Number.isNaN(route[i]) ? route[i] : Number(route[i]);
        if (!current[key] || typeof current[key] !== 'object') {
            current[key] = !Number.isNaN(route[i + 1]) ? [] : {};
        }
        current = current[key];
    }
    current[route[route.length - 1]] = value;
}
//# sourceMappingURL=helpers.js.map